import { Directive, Input, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { Store } from '@ngrx/store';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import {
  selectResolvedSettingByPathAsBoolean,
  selectResolvedSettingByPathAsString,
} from '@main/settings/store/settings.selectors';
import { combineLatest } from 'rxjs';
import { distinctUntilChanged, map } from 'rxjs/operators';

export type ExternalAccountSystem = 'Sage 50 US' | 'Sage 300' | 'QuickBooks Online';

@UntilDestroy()
@Directive({
    selector: '[appIfExternalAccountingEnabled]',
    standalone: true
})
export class IfExternalAccountingEnabledDirective implements OnInit {
  @Input()
  set appIfExternalAccountingEnabled(externalAccountingSystemName: ExternalAccountSystem) {
    this.externalAccountingSystemName = externalAccountingSystemName;
  }

  private externalAccountingSystemName: ExternalAccountSystem;

  constructor(
    private store: Store,
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
  ) { }

  ngOnInit() {
    combineLatest([
      this.store.pipe(selectResolvedSettingByPathAsBoolean(['accounting', 'enableExternalAccounting'])),
      this.store.pipe(selectResolvedSettingByPathAsString(['accounting', 'externalAccountingSystem'])),
    ]).pipe(
      map(([externalAccountingEnabled, externalAccountingSystem]) => {
        return externalAccountingEnabled && this.externalAccountingSystemName && externalAccountingSystem === this.externalAccountingSystemName;
      }),
      distinctUntilChanged(),
      untilDestroyed(this),
    ).subscribe(show => this.refreshView(show));
  }

  private refreshView(show: boolean) {
    this.viewContainer.clear();
    if (show) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    }
  }
}
